export default __webpack_public_path__ + "static/media/aws.a59d5ca6.png";